import _createClass from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import Vue from 'vue';
import Vuex from 'vuex';
import jslinq from 'jslinq';
Vue.use(Vuex);

var AppState = /*#__PURE__*/_createClass(function AppState() {
  _classCallCheck(this, AppState);

  this.gtagId = 'G-9X4PQ698QV';
  this.configLentiV = false;
  this.carrelloDialog = false;
  this.loginDialog = false;
  this.storicoOrdiniDialog = false;
  this.erroreLentiDialog = false;
  this.affogatiEnabled = false;
  this.tintaUnita = true;
  this.mappedTempleColors = new Map();
  this.activetemple = null;
  this.cachedAsteAffogati = [];
  this.cachedAsteNonAffogati = [];
  this.personalizationRemoved = false;
  this.lenteSx = null;
  this.lenteDx = null;
});

export default new Vuex.Store({
  state: new AppState(),
  mutations: {
    resetRowNotes: function resetRowNotes(state) {
      state.configurator.note = '';
    },
    setPersonalizationRemoved: function setPersonalizationRemoved(state, value) {
      state.personalizationRemoved = value;
    },
    openCloseConfigLentiV: function openCloseConfigLentiV(state, c) {
      state.configLentiV = c;
    },
    openCloseCarrelloDialog: function openCloseCarrelloDialog(state, c) {
      state.carrelloDialog = c;
    },
    openCloseLoginDialog: function openCloseLoginDialog(state, c) {
      state.loginDialog = c;
    },
    openCloseStoricoOrdiniDialog: function openCloseStoricoOrdiniDialog(state, c) {
      state.storicoOrdiniDialog = c;
    },
    openCloseDialogErroreLenti: function openCloseDialogErroreLenti(state, c) {
      if (!c || !state.configLentiV) state.erroreLentiDialog = c;
    },
    setActiveTemple: function setActiveTemple(state, t) {
      state.activetemple = t;
    },
    setTintaUnita: function setTintaUnita(state, n) {
      state.tintaUnita = n;
    },
    setLenteSx: function setLenteSx(state, l) {
      state.lenteSx = l;
    },
    setLenteDx: function setLenteDx(state, l) {
      state.lenteDx = l;
    },
    setAffogatiEnabled: function setAffogatiEnabled(state, a) {
      state.affogatiEnabled = a;
    },
    setMappedTempleColors: function setMappedTempleColors(state, m) {
      state.mappedTempleColors = m;
    },
    resetConfiguration: function resetConfiguration(state, _ref) {
      var forma = _ref.forma,
          colore = _ref.colore,
          coloreAste = _ref.coloreAste,
          sizeDescription = _ref.sizeDescription;

      if (sizeDescription && state.configurator.frontali !== undefined) {
        var regularSize = state.configurator.frontali.itemsSizes.filter(function (size) {
          return size.size_description == sizeDescription && size.U_THE_MODELLO == forma;
        });
        state.configurator.calibro = regularSize[0].size_eye;
        state.configurator.naso = regularSize[0].size_bridge;
      } else {
        state.configurator.calibro = '';
        state.configurator.naso = '';
      }

      state.configurator.asianFitting = false;

      if (state.configurator.frontali != undefined) {
        var _state$configurator$f;

        state.configurator.colore = (_state$configurator$f = state.configurator.frontali.colors.find(function (col) {
          return col.U_THE_COLORE == (colore ? colore : "EP0001");
        })) !== null && _state$configurator$f !== void 0 ? _state$configurator$f : null;
      } else {
        state.configurator.colore = null;
      }

      state.configurator.finitura = "S";
      state.configurator.misuraAste = '145';

      if (state.configurator.aste != undefined) {
        var _state$configurator$a;

        state.configurator.coloreAste = (_state$configurator$a = state.configurator.aste.allColors.find(function (col) {
          return col.U_THE_COLORE == (coloreAste ? coloreAste : "PL0001") && col.U_THE_LUNGASTA == state.configurator.misuraAste;
        })) !== null && _state$configurator$a !== void 0 ? _state$configurator$a : null;
      }

      state.configurator.coloreMetalloAste = "";
      state.configurator.finituraAste = "S"; // TODO: verificare come resettare le variabili di seguito

      if (state.configurator.frontali) {
        state.configurator.frontali.name = "";
        state.configurator.frontali.nameFont = "Batang";
        state.configurator.frontali.nameColor = "";
      }

      if (state.configurator.aste) {
        state.configurator.aste.extSxName = '';
        state.configurator.aste.extSxNameColor = '';
        state.configurator.aste.extSxNameFont = 'Batang';
        state.configurator.aste.intSxName = '';
        state.configurator.aste.intSxNameColor = '';
        state.configurator.aste.intSxNameFont = 'Batang';
        state.configurator.aste.extDxName = '';
        state.configurator.aste.extDxNameColor = '';
        state.configurator.aste.extDxNameFont = 'Batang';
        state.configurator.aste.intDxName = '';
        state.configurator.aste.intDxNameColor = '';
        state.configurator.aste.intDxNameFont = 'Batang';
      }

      state.configurator.note = "";

      if (forma && state.configurator.frontali != undefined) {
        if (forma.indexOf('S') >= 0 && state.configurator.glassType == 'V') {
          forma = forma.replace('S', '');
          var f = jslinq(state.configurator.frontali.items);
          var fd = f.firstOrDefault(function (front) {
            return front.U_THE_MODELLO == forma;
          }); // this.setFrontale(fd)

          state.configurator.frontale = fd;
        } else if (forma.indexOf('S') >= 0 && state.configurator.glassType == 'S') {
          var _f = jslinq(state.configurator.frontali.items);

          var _fd = _f.firstOrDefault(function (front) {
            return front.U_THE_MODELLO == forma;
          });

          state.configurator.frontale = _fd;
        }
      }
      /* else {
      state.frontale = state.frontale;
      }*/

    },
    resetLentiVista: function resetLentiVista(state) {
      state.configurator.lenteVistaDx = null;
      state.configurator.lenteVistaSx = null; // state.configurator.lenti!.sferaDx = 0;
      // state.configurator.lenti!.sferaSx = 0;
      // state.configurator.lenti!.cilindroDx = 0;
      // state.configurator.lenti!.cilindroSx = 0;
      // state.configurator.lenti!.asseDx = 0;
      // state.configurator.lenti!.asseSx = 0;
      // state.configurator.lenti!.semiDistDx = 0;
      // state.configurator.lenti!.semiDistSx = 0;
      // state.configurator.lenti!.altPupDx = 0;
      // state.configurator.lenti!.altPupSx = 0;
      // state.configurator.lenti!.addDx = 0;
      // state.configurator.lenti!.addSx = 0;
    },
    resetPersonalizzazioniAste: function resetPersonalizzazioniAste(state) {
      if (state.configurator.aste) {
        state.configurator.aste.extSxName = '';
        state.configurator.aste.extSxNameColor = '';
        state.configurator.aste.extSxNameFont = '';
        state.configurator.aste.intSxName = '';
        state.configurator.aste.intSxNameColor = '';
        state.configurator.aste.intSxNameFont = '';
        state.configurator.aste.extDxName = '';
        state.configurator.aste.extDxNameColor = '';
        state.configurator.aste.extDxNameFont = '';
        state.configurator.aste.intDxName = '';
        state.configurator.aste.intDxNameColor = '';
        state.configurator.aste.intDxNameFont = '';
      }
    }
  },
  actions: {},
  modules: {},
  getters: {
    filteredTemples: function filteredTemples(state, getters) {
      if (state.affogatiEnabled) {
        var _state$configurator$f2;

        var height = (_state$configurator$f2 = state.configurator.frontale) !== null && _state$configurator$f2 !== void 0 && _state$configurator$f2.ModelName ? getters.getLastNumberFromString(state.configurator.frontale.ModelName) : null;

        if (height) {
          // Rimuove il punto e converte in numero
          var numericHeight = parseInt(height.replace(".", "")); // Accede alla mappa con la chiave numerica

          var temples = state.mappedTempleColors.get(numericHeight); // Usa numericHeight

          return Array.isArray(temples) ? temples : [];
        }

        return [];
      } else {
        var _state$configurator$a2;

        return (((_state$configurator$a2 = state.configurator.aste) === null || _state$configurator$a2 === void 0 ? void 0 : _state$configurator$a2.allColors) || []).filter(function (temple) {
          var _temple$U_THE_MODELLO, _temple$U_THE_MODELLO2;

          return !((_temple$U_THE_MODELLO = temple.U_THE_MODELLO) !== null && _temple$U_THE_MODELLO !== void 0 && _temple$U_THE_MODELLO.includes("75")) && !((_temple$U_THE_MODELLO2 = temple.U_THE_MODELLO) !== null && _temple$U_THE_MODELLO2 !== void 0 && _temple$U_THE_MODELLO2.includes("12"));
        });
      }
    },
    getLastNumberFromString: function getLastNumberFromString() {
      return function (inputString) {
        var pattern = /(\d{1,3}(?:[.,]\d{3})*(?:[.,]\d+)?)(?=\D*$|$)/;
        var match = inputString.match(pattern);
        return match ? match[0].replace(",", ".") : "";
      };
    }
  }
});